import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const HIDE_ACTIVE_BUSINESS_TENANT_IDS = [
  '6d825202-2bee-4b19-8b14-f09c65359e05', // wsc
  '6d825201-2bee-4b19-8b14-f09c65359e25', // wsc v2
  '6d825202-2bee-4b19-8b14-f09d65359a10', // wsc sandbox
];

const DunsControlStatus = ({ dunsControlStatus, tenantId }) => {
  if (!dunsControlStatus) {
    return null;
  }

  const hideActiveBusiness = HIDE_ACTIVE_BUSINESS_TENANT_IDS.includes(String(tenantId || '').trim());

  const statusItems = [
    ...(!hideActiveBusiness ? [{ label: 'Active Business', value: !dunsControlStatus.isOutOfBusiness }] : []),
    { label: 'Marketable', value: dunsControlStatus.isMarketable },
    { label: 'Phone Active', value: !dunsControlStatus.isTelephoneDisconnected },
    { label: 'Mail Deliverable', value: !dunsControlStatus.isMailUndeliverable },
    { label: 'Listed', value: !dunsControlStatus.isDelisted },
  ];

  return (
    <Box sx={{ padding: "0 25px", marginTop: "20px", marginBottom: "20px" }}>
      <Typography
        sx={{
          textAlign: "left",
          fontSize: "20px",
          color: "#1A2A56",
          fontWeight: "600",
          marginBottom: "15px",
        }}
      >
        Control Status
      </Typography>
      <Paper
        sx={{
          background: "#FAFAFC",
          boxShadow:
            "inset 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 3px 6px rgba(0, 0, 0, 0.16)",
          borderRadius: "8px",
          opacity: 1,
          padding: "25px",
        }}
      >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(${statusItems.length}, 1fr)`,
          gap: 2
        }}
      >
        {statusItems.map((item, index) => (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {!item.value ? (
              <CancelOutlinedIcon sx={{ color: '#FF4D4D' }} />
            ) : (
              <CheckCircleOutlineIcon sx={{ color: '#219653' }} />
            )}
            <Typography sx={{ fontSize: '16px', color: '#4A4A4A' }}>
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>
      </Paper>
    </Box>
  );
};

export default DunsControlStatus;
